export function getProjectInternalId(projectId: string | undefined) {
  return projectId ? btoa('ProjectInternalId:' + projectId) : undefined;
}
